import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'HomePage',

  computed: {
    ...mapGetters(['alert']),
  },

  methods: {
    ...mapActions(['LOGOUT', 'ALERT_HIDE']),

    help() {

    },

    logout() {
      this.LOGOUT();
    },
  },

  mounted() {
    // this.LOGIN_SUCCESS();
    // console.log(this.$router.currentRoute);
    if (this.$router.currentRoute.name === 'dashboard') {
      this.$router.push({ name: 'apps' });
    } else {
      this.$router.push({ name: this.$router.currentRoute.name });
    }
  },
};
